import { useMutation } from "@tanstack/react-query";
import { isWafCaptchaResponse } from "@/hooks/useWafCaptcha";
export const useSignup = ()=>{
    return useMutation({
        mutationFn: async ({ data, captchaToken })=>{
            const headers = {
                'Content-Type': 'application/json'
            };
            // Include CAPTCHA token if provided
            if (captchaToken) {
                headers['x-aws-waf-token'] = captchaToken;
            }
            const response = await fetch(`${import.meta.env.VITE_API_URL}/direct/auth/signup`, {
                method: 'POST',
                headers,
                body: JSON.stringify(data)
            });
            // Check for WAF CAPTCHA challenge
            if (isWafCaptchaResponse(response)) {
                const error = new Error('CAPTCHA_REQUIRED');
                throw error;
            }
            if (!response.ok) {
                const errorData = await response.json().catch(()=>({}));
                throw new Error(errorData.message || 'Signup failed');
            }
            return response.json();
        },
        onError: ()=>{
        // Signup error occurred
        }
    });
};
